function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1200 1200"
}, props), React.createElement("path", {
  fill: "#2C2C2C",
  d: "M599.997 1150C296.73 1150 50 903.27 50 599.997 50 296.73 296.73 50 599.997 50 903.271 50 1150 296.73 1150 599.997 1150 903.27 903.271 1150 599.997 1150zm0-1024.169c-261.455 0-474.166 212.711-474.166 474.167 0 261.461 212.711 474.172 474.166 474.172 261.461 0 474.172-212.711 474.172-474.172 0-261.456-212.711-474.167-474.172-474.167z"
}), React.createElement("path", {
  fill: "#2C2C2C",
  d: "M495.81 858.085c-.205 0-.404 0-.61-.005a37.918 37.918 0 0 1-28.972-14.191l-168.66-210.318c-13.102-16.338-10.481-40.2 5.856-53.302 16.338-13.079 40.206-10.481 53.302 5.861l140.042 174.625L844.055 355.17c13.626-15.91 37.557-17.756 53.461-4.142 15.904 13.621 17.762 37.557 4.141 53.461L524.611 844.83a37.926 37.926 0 0 1-28.801 13.255z"
})));